import { Modal, ModalProps } from 'ui';

import { VenmoAccountForm } from '../../forms/VenmoAccountForm/VenmoAccountForm';

interface VenmoAccountModalProps extends ModalProps {
  modalProps?: Partial<ModalProps>;
}

const VenmoAccountModal = ({ opened, onClose, modalProps, title }: VenmoAccountModalProps) => {
  return (
    <Modal opened={opened} onClose={onClose} title={title ?? 'Connect My Venmo'} {...modalProps}>
      <VenmoAccountForm onClose={onClose} />
    </Modal>
  );
};

export { VenmoAccountModal };
